import React from 'react';
import styled from "styled-components";
import { Link } from 'react-router-dom';
import { Instagram, LinkedIn, Telegram, Email } from '@mui/icons-material';

const FooterContainer = styled.footer`
  background-color: var(--color-bg);
  color: var(--color-text);
  padding: 4rem 2rem;
  border-top: 1px solid rgba(0,0,0,0.1);
  margin-top: auto;
`;

const ContentWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
`;

const BrandSection = styled.div`
  text-align: center;
`;

const BrandTitle = styled.h3`
  font-family: var(--font-serif);
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: var(--color-primary-blue);
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 2rem;
  
  a {
    color: var(--color-text);
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      color: var(--color-primary-blue);
      transform: translateY(-2px);
    }
  }
`;

const FooterNav = styled.nav`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  justify-content: center;

  a {
    font-size: 0.9rem;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--color-text-light);
    text-decoration: none;

    &:hover {
      color: var(--color-primary-blue);
    }
  }
`;

const Copyright = styled.div`
  font-size: 0.8rem;
  color: var(--color-text-light);
  opacity: 0.6;
  margin-top: 2rem;
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <ContentWrapper>
        <BrandSection>
          <BrandTitle>SHALOM EPFL</BrandTitle>
          <p style={{ opacity: 0.7, maxWidth: '400px', margin: '0 auto' }}>
            Connecting students through Israeli culture, innovation, and academic excellence.
          </p>
        </BrandSection>

        <FooterNav>
          <Link to="/activities">Events</Link>
          <Link to="/donation">Donate</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/become-a-member">Join Us</Link>
        </FooterNav>

        <SocialLinks>
          <a href="https://www.instagram.com/shalom_epfl/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <Instagram fontSize="large" />
          </a>
          <a href="https://www.linkedin.com/company/shalom-epfl/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <LinkedIn fontSize="large" />
          </a>
          <a href="https://t.me/shalomepfl" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
            <Telegram fontSize="large" />
          </a>
          <a href="mailto:shalom@epfl.ch" aria-label="Email">
            <Email fontSize="large" />
          </a>
        </SocialLinks>

        <Copyright>
          © {currentYear} Shalom EPFL. All rights reserved.
        </Copyright>
      </ContentWrapper>
    </FooterContainer>
  );
};

export default Footer;